import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/avisoItem/';

class AvisoItemService{
  constructor(){
		LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type':'application/json',
				'authorization':'Bearer ' + (data ? data.token:'')
			};
		});
	}

	findItemById(id){
		return axios.get(API_URL + 'id?id='+id, {headers: this.headers});
	}

  findAllItensByFiltro(idCliente, filtro){
    return axios.get(API_URL + "allItens?idCliente="+idCliente+"&filtro="+filtro, {headers: this.headers});
  }

	findItem(idCliente, filtro){
    return axios.get(API_URL+ 'allItens?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data));
  }

  saveItem(item){
    return axios.post(API_URL, JSON.stringify(item), {headers: this.headers});
  }

  removeItens(id){
		return axios.delete(API_URL + id ,{headers: this.headers});
	}
}

export default new AvisoItemService();